<script>
  import { html } from 'common-tags';

  import ChoiceInput from './choice-input.svelte';

  export let value;

  export let onChange = () => {};

  const options = [
    { value: 'uppercase', label: 'uppercase', html: 'ABC' },
    { value: 'lowercase', label: 'lowercase', html: 'abc' },
    { value: 'capitalize', label: 'capitalize', html: 'Abc' },
    { value: 'none', label: 'none' }
  ];
</script>

<ChoiceInput {value} {options} {onChange} />
